module.exports = __webpack_public_path__ + "assets/media/day23.f5ed2576.mp3";